<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs10 offset-xs1>
        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <h1 class="display-1 mb-5">Update Password </h1>
              <div v-if="!$v.currentPassword.required" class="red--text">Please enter Current Password</div>
              <v-text-field label="Current Password" v-model="currentPassword"></v-text-field>
              <div v-if="!$v.password.required" class="red--text">Please enter New Password</div>
              <v-text-field label="New Password" v-model="password"></v-text-field>
              <div v-if="!$v.confirmPassword.required" class="red--text">Please enter Confirm Password</div>
              <v-text-field label="Confirm Password" v-model="confirmPassword"></v-text-field>
              <v-btn large color="primary" @click="updatePassword">Update Password</v-btn>
            </v-flex>
            <v-snackbar dark top v-model="snackbar" :timeout="3000">
              {{ popupText }}
              <v-btn dark flat @click="snackbar = false">Close</v-btn>
            </v-snackbar>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import UserService from '@/services/UserService.js'
import { required } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      snackbar: false,
      popupText: null,
      currentPassword: null,
      password: null,
      confirmPassword: null,
      loggedInUser: JSON.parse(atob(localStorage.getItem('user')))
    }
  },
  mounted () {
  },
  validations: {
    currentPassword: { required },
    password: { required },
    confirmPassword: { required }
  },
  methods: {
    async updatePassword () {
      if (!this.validateFields()) {
        return
      }
      var params = { email: this.loggedInUser.email, currentPassword: this.currentPassword, password: this.password, confirmPassword: this.confirmPassword }
      const response = await UserService.updatePassword(params)
      this.popupText = response.data.message
      this.snackbar = true
      if (response.data.success === true) {
        this.currentPassword = this.password
        this.password = null
        this.confirmPassword = null
      }
      console.log(response)
    },
    validateFields () {
      this.$v.currentPassword.$touch()
      this.$v.password.$touch()
      this.$v.confirmPassword.$touch()

      if (this.$v.currentPassword.$pending || this.$v.currentPassword.$error) return false
      if (this.$v.password.$pending || this.$v.password.$error) return false
      if (this.$v.confirmPassword.$pending || this.$v.confirmPassword.$error) return false
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/UpdatePassword.vue